(function(window, _, wattpad, app) {
  "use strict";
  // Urgent announcement: server-rendered in its own container and bound here
  // (via setupAnnouncements) so it always shows, stacked, and independent of
  // the mutually-exclusive #announcements. Inherits the base announcement
  // click -> stopEvent / tap -> onDismiss handling; dismissal is short-lived
  // (urgent-announcement-dismissed cookie, ~3h) so users keep being reminded
  // until the URGENT_ANNOUNCEMENT flag is turned off.
  app.add(
    "Urgent",
    app.views.Announcement.extend({
      className: app.views.Announcement.prototype.className + " urgent",

      onDismiss: function() {
        $("#urgent-announcement-container").remove();
        this.remove();
        wattpad.utils.setCookie("urgent-announcement-dismissed", "1", 0.125);
      }
    })
  );
})(window, _, wattpad, window.app);
